module.exports = __webpack_public_path__ + "img/Download.688144f1.svg";